export const DEFAULT_CONFIRMATION_MESSAGE =
  'Thanks! We’ll call and email you shortly to finalize your website details.';
export const DEFAULT_CONFIRMATION_BUTTON_TEXT = 'Submit Another Request';
export const ADMIN_CONFIRMATION_MESSAGE = 'Nice Work! Got any more?';
export const EXTERNAL_SALES_CONFIRMATION_MESSAGE =
  'Thanks, we will reach out to the merchant when their preview site is ready.';
